import { interval, Subscription } from 'rxjs';

export class BackgroundAction {

  public constructor(
    private readonly _intervalSeconds: number,
    private readonly _action: () => void,
  ) {}

  private _sub$: Subscription;

  public start(): void {
    if (this._sub$) {
      this.stop();
    }

    this._sub$ = interval(this._intervalSeconds * 1000).subscribe(this._action);
  }

  public stop(): void {
    this._sub$?.unsubscribe();
    this._sub$ = null;
  }
}
